import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import Home from "./pages/Home";
import Login from "./pages/auth/Login";
import Register from "./pages/auth/Register";
import ForgotPassword from "./pages/auth/ForgotPassword";

import GameList from "./pages/topup/GameList";
import MobileList from "./pages/topup/MobileList";
import CardList from "./pages/topup/CardList";
import TopupDetail from "./pages/topup/TopupDetail";

import PromotionList from "./pages/promotions/PromotionList";
import PromotionDetail from "./pages/promotions/PromotionDetail";

import CartPage from "./pages/cart/CartPage";
import QrPayment from "./pages/payment/QrPayment";

import About from "./pages/About";
import Policy from "./pages/Policy";
import OrderSuccess from "./pages/OrderSuccess";
import NotFound from "./pages/NotFound";

import ProfileSettings from "./pages/profile/ProfileSettings";
import AddressPage from "./pages/profile/AddressPage";
import HistoryPage from "./pages/profile/HistoryPage";

const AppRoutes = () => (
  <Routes>
    <Route path="/" element={<Home />} />

    {/* auth */}
    <Route path="/login" element={<Login />} />
    <Route path="/register" element={<Register />} />
    <Route path="/forgot-password" element={<ForgotPassword />} />

    {/* topup */}
    <Route path="/topup/game" element={<GameList />} />
    <Route path="/topup/game/:id/:slug" element={<TopupDetail kind="game" />} />
    <Route path="/topup/game/:id" element={<TopupDetail kind="game" />} />
    <Route path="/topup/mobile" element={<MobileList />} />
    <Route path="/topup/mobile/:id/:slug" element={<TopupDetail kind="mobile" />} />
    <Route path="/topup/mobile/:id" element={<TopupDetail kind="mobile" />} />
    <Route path="/topup/card" element={<CardList />} />
    <Route path="/topup/card/:id/:slug" element={<TopupDetail kind="card" />} />
    <Route path="/topup/card/:id" element={<TopupDetail kind="card" />} />

    {/* cart & payment */}
    <Route path="/cart" element={<CartPage />} />
    <Route path="/payment/qr/:transactionId" element={<QrPayment />} />

    {/* promotions & static */}
    <Route path="/promotions" element={<PromotionList />} />
    <Route path="/promotions/detail/:id" element={<PromotionDetail />} />
    <Route path="/about" element={<About />} />
    <Route path="/policy" element={<Policy />} />
    <Route path="/order/success" element={<OrderSuccess />} />

    {/* profile */}
    <Route path="/profile" element={<ProfileSettings />} />
    <Route path="/profile/address" element={<AddressPage />} />
    <Route path="/profile/topup-game-history" element={<HistoryPage type="game" />} />
    <Route path="/profile/topup-mobile-history" element={<HistoryPage type="mobile" />} />
    <Route path="/profile/topup-card-history" element={<HistoryPage type="card" />} />
    <Route path="/profile/product-history" element={<HistoryPage type="product" />} />

    {/* legacy redirects */}
    <Route path="/topup/credit" element={<Navigate to="/topup/game" replace />} />
    <Route path="/profile/topup-history" element={<Navigate to="/profile/topup-game-history" replace />} />
    <Route path="/profile/kyc" element={<Navigate to="/profile" replace />} />
    <Route path="/profile/login-history" element={<Navigate to="/profile" replace />} />
    <Route path="/profile/support-tickets" element={<Navigate to="/profile" replace />} />
    <Route path="/game-uid" element={<Navigate to="/topup/game" replace />} />
    <Route path="/topup-id-pass" element={<Navigate to="/topup/game" replace />} />
    <Route path="/card-topup" element={<Navigate to="/topup/card" replace />} />
    <Route path="/policy-privacy" element={<Navigate to="/policy" replace />} />

    <Route path="*" element={<NotFound />} />
  </Routes>
);

export default AppRoutes;
